import { render } from "./DonationTargetAccordion.vue?vue&type=template&id=f1c04e88&scoped=true"
import script from "./DonationTargetAccordion.vue?vue&type=script&lang=js"
export * from "./DonationTargetAccordion.vue?vue&type=script&lang=js"

import "./DonationTargetAccordion.vue?vue&type=style&index=0&id=f1c04e88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c04e88"]])

export default __exports__